import { useState, useEffect } from 'react';

const useLoadingSimulation = () => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setIsLoading(false);
    }, 10000);

    return () => clearTimeout(timeoutId);
  }, []);

  return isLoading;
};

export default useLoadingSimulation;
